import { toast } from 'react-hot-toast';

/*
    Guard for the dashboard's "Delete permanently" buttons. Those remove the record from
    the database for good, so a plain OK/Cancel box, which is easy to click through, is
    not enough: the person has to type DELETE.

    Returns true only when they typed it. Cancelling does nothing; typing something else
    says why nothing happened, so a wrong word is not mistaken for a failed delete.
*/
export const CONFIRM_WORD = 'DELETE';

export const confirmPermanentDelete = (what, hint = '') => {
  const answer = window.prompt(
    `Permanently delete ${what}? This cannot be undone.${hint ? `\n\n${hint}` : ''}\n\nType ${CONFIRM_WORD} to confirm.`
  );
  if (answer === null) return false;
  if (answer.trim() !== CONFIRM_WORD) {
    toast.error(`Nothing was deleted: you did not type ${CONFIRM_WORD}.`);
    return false;
  }
  return true;
};
